(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nav-primary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const navPrimary = document.getElementById('nav-primary');
    if (!navPrimary) return;

    const tabButtons = navPrimary.querySelectorAll('.ab-test-tab-button');
    const tabContents = navPrimary.querySelectorAll('.ab-test-tab-content');
    const gridContents = navPrimary.querySelectorAll('.ab-test-bottom-promo-grid');

    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        console.log('tab clicked')
        // Deactivate all buttons and content
        tabButtons.forEach(btn => btn.classList.remove('is-active'));
        tabContents.forEach(content => content.classList.remove('is-active'));
        gridContents.forEach(content => content.classList.remove('is-active'));

        // Activate the clicked button
        button.classList.add('is-active');

        // Activate the corresponding content
        const target = document.querySelector(button.dataset.tabTarget);
        const gridTarget = document.querySelector(button.dataset.gridTarget);
        if (target) {
          target.classList.add('is-active');
        }
        console.log('gridTarget', gridTarget)
        if (gridTarget) {
          gridTarget.classList.add('is-active');
        }
      });
    });

    // A/B Test 2: Page switching functionality
    const goToPage2Button = navPrimary.querySelector('.js-nav-go-to-page-2');
    const goToPage1Button = navPrimary.querySelector('.js-nav-go-to-page-1');

    if (goToPage2Button && goToPage1Button) {
      goToPage2Button.addEventListener('click', function() {
        navPrimary.classList.add('page-2-active');
      });

      goToPage1Button.addEventListener('click', function() {
        navPrimary.classList.remove('page-2-active');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
